<template>
  <div class="bear-sign">
    <template v-if="options.result">
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        custom-class="dlg-bear-sign"
        v-model="options.result"
        width="600px"
      >
        <ul class="text-left">
          <li>
            第一步：
            <a v-if="isNormal" :href="options.json.sx_url">{{openSignConfig.step_1}}</a>
            <a v-else href="#" @click="message">请点击我打开签章程序。</a>
          </li>
          <li>第二步：请点击下面确定按钮。</li>
          <li>
            <a :href="openSignConfig.sxcaWeb" target="_blank">若点击无反应，请下载安装签章软件</a>
          </li>
        </ul>

        <template #footer>
          <a
            v-if="options.json.fjggfw_url"
            class="pull-left a-link"
            href="javascript:;;"
            style="font: normal 14px/30px microsoft yahei"
            @click="showProvinceSignWin"
            >{{openSignConfig.switch_text}}</a>
          <el-button @click="fnCancel">取 消</el-button>
          <el-button type="primary" @click="fnOk">确 定</el-button>
        </template>
      </el-dialog>
    </template>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      v-model="provinceSignWinVisible"
      width="800px"
      custom-class="dlg-bear-sign"
    >
      <div class="wosp-container">
        <hr />
        <p class="text-center">
          <a :href="options.json && options.json.fjggfw_url" style="text-decoration: none">
            <el-button type="primary" :data-ca="options.json && options.json.fjggfw_url" @click="jumpToProviceSign"
              >福建省统一CA</el-button
            >            
          </a>
        </p>
        <h2 class="text-center">重要声明</h2>
        <p>
          1、使用前请点击<a
            target="_blank"
            class="a-link"
            :href="openSignConfig.fjcaWeb"
            >下载</a
          >，按福建省公共资源电子公共服务平台指引进行客户端安装。安装完成后，请
          <a
            target="_blank"
            class="a-link"
            :href="openSignConfig.fjcaUtil"
            rel="noopener noreferrer"
            >下载统一CA调用工具</a
          >
          进行安装，再点击上方按键“福建省统一CA”进行签章。
        </p>
        <p>
          2、由于福建省统一CA技术由福建省公共资源交易电子公共服务平台提供，若使用此功能遇到客户端无法安装、打开、无法签章等情况请直接联系福建省公共服务平台客服热线“400-9955-015”或CA厂商。交易平台对此功能不负任何责任。
        </p>
        <p>3、深圳CA已全新升级系统，签章更快、更高效，推荐选择深圳CA。</p>
        <p>
          <a
            target="_blank"
            :href="openSignConfig.szcaWeb"
            class="a-link"
            rel="noopener noreferrer"
            >深圳CA在线申请链接</a
          >
        </p>
        <div style="height: 15px;"></div>
        <hr />
        <p>说明：签章完成后，请点击“签章完成”按钮，完成本次签章</p>
      </div>
      <template #footer>
        <el-button @click="fnCancel">取消签章</el-button>
        <el-button type="primary" @click="fnOk">签章完成</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: "BearSign",
  props: {
    options: {
      type: Object,
      default() {
        return {
          result: false,
          json: {
            url: "",
            sx_url: "",
            fjggfw_url: ""
          },
          msg: ""
        };
      }
    },
    isRefresh: {
      type: Boolean,
      default: true
    },
    Messages: {
      type: Boolean,
      default: false
    },
    isComFirmParam: {
      type: Boolean,
      default: false
    },
    isSign: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '签章'
    }
  },
  computed: {
    ...mapState(['openSignConfig']),
    isNormal() {
      return this.options.json !== null;
    }
  },
  watch: {
    options() {
      let {result, json} = this.options
      if (result && !json.sx_url) {
        this.showProvinceSignWin()
      }
    }
  },
  data() {
    return {
      provinceSignWinVisible: false,
      // urlConfig: { // 已改为 openSignConfig
      //   step_1: '请点击我打开签章程序。支持深圳cA',
      //   switch_text: '福建省统一CA点我签章（瑞术、凯特、恒瑞通、首众）'
      // }
    };
  },
  methods: {
    ...mapActions(['doGet']),
    message() {
      let options = this.options;
      if (options.result) {
        if (options.json === null) {
          this.$message.error(options.msg | "生成签章失败");
        }
      } else {
        this.$message.warning('拒绝生成签章');
      }
    },
    refresh() {
      if (this.isRefresh) {
        location.reload();
      } else {
        this.options.result = this.provinceSignWinVisible = false;
      }
      if (this.isComFirmParam) {
        //确定或者取消后的方法
        this.$emit("flowcomFirmMethod", "");
      }
      if (this.isSign) {
        //pdf签章确定或者取消后的方法
        this.$emit("pdfSignMethod", "");
      }
    },
    fnOk() {
      if (this.Messages){
        this.options.result = this.provinceSignWinVisible = false;
      }
      else {
        this.refresh();
      } 
    },
    fnCancel() {
      this.options.result = this.provinceSignWinVisible = false;
      this.Messages || this.refresh();
    },
    showProvinceSignWin() {
      this.options.result = false;
      this.provinceSignWinVisible = true;
    },
    jumpToProviceSign() {
      window.open(this.options.json.fjggfw_url, "_self");
    }
  }
};
</script>
<style lang="scss" scoped>
.bear-sign {
  text-align: left;
  ul {
    list-style: none;
    line-height: 50px;
    font-size: 16px;
  }
  ul a {
    color: #20a0ff;
    text-decoration: none;
  }
}
</style>
<style lang="scss">
.bear-sign {
  .pull-left {
    float: left;
  }
  h2 {
    font-size: 25px;
    line-height: 20px;
  }
  p {
    text-align: left;
    font-size: 16px;
    line-height: 25px;
    margin: 15px 0;
  }
  .text-center {
    text-align: center;
  }
  .wosp-container {
    margin: -25px 0 -50px;
  }
  .a-link {
    color: #20a0ff;
    text-decoration: none;
  }
}
.dlg-bear-sign {
  .el-dialog__headerbtn {
    .el-dialog__close {
      font-size: 28px;
    }    
  }
}
</style>